import { CreateQuoteStoreForm } from '../types'

const build = (
  props: Pick<CreateQuoteStoreForm, 'id' | 'pickupAddress'>
): CreateQuoteStoreForm => ({
  ...props,
  pickup: false,
  timingDetails: '',
})

export default { build }
